// src/app/services/alert.service.ts
import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { NzModalService } from 'ng-zorro-antd/modal';
import { SecondStepSicknessComponent } from '../secure/dashboard/components/calendar/request-modal/second-step/second-step-sickness/second-step-sickness.component';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  text: string;
  // input arrivati dal componente Calendar
  request?: any;
  user: any;
  date: string;

  constructor(private readonly modalService: NzModalService) {}

  showSuccessRequestAlert(text: string | undefined, date?: string): void {
    Swal.fire({
      title: 'Richiesta inviata!',
      text: 'La tua richiesta ' + text + ' è stata inviata con successo.',
      icon: 'success',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#1C447D',
      color: '#1C447D',
      customClass: {
        confirmButton: 'my-swal-button',
        icon: 'my-swal-icon'
      }
    });
  }

  showEditRequestAlert(text: string | undefined, date?: string): void {
    Swal.fire({
      title: 'Richiesta modificata!',
      text: 'La tua richiesta ' + text + ' è stata modificata con successo.',
      icon: 'success',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#1C447D',
      color: '#1C447D',
      customClass: {
        confirmButton: 'my-swal-button',
        icon: 'my-swal-icon'
      }
    });
  }

  showErrorRequestAlert(): void {
    Swal.fire({
      title: 'Richiesta non inviata!',
      text: 'La tua richiesta non è stata inviata, ci dispiace.',
      icon: 'error',
      confirmButtonText: 'ok',
      confirmButtonColor: '#1C447D',
      color: '#1C447D',
      customClass: {
        confirmButton: 'my-swal-button',
        icon: 'my-swal-icon'
      }
    });
  }
}
